import React from 'react';
import Footer from "./Footer";
import DashboardHeader from "./DashboardHeader";

const DashboardLayout = ({...props}) => {
    return (
        <div className="min-h-screen flex flex-col">
            <DashboardHeader />
            <div className="w-full flex flex-col items-center flex-1 ">
                {props.children}
            </div>
            <Footer/>
        </div>
    );
};

export default DashboardLayout;